import { get } from '@services/local-storage-service'
import { useHistory } from 'react-router'
import React, { useEffect } from 'react'
import { AUTHED_INFOR_LOCAL_STORAGE } from '@const/auth'
import { warn } from '@services/toast-service'

export function withPreventFromUser<T> (WrappedComponent: React.ComponentType<T>) {
  const displayName = WrappedComponent.displayName || WrappedComponent.name || 'Component'

  const ComponentWithPreventFromUser = (props: T) => {
    const router = useHistory()

    useEffect(() => {
      if (get(AUTHED_INFOR_LOCAL_STORAGE)) {
        warn('ログインしています')
        router.push('/')
      }
    }, [router])

    return <WrappedComponent {...props} />
  }

  ComponentWithPreventFromUser.displayName = `withPreventFromUser(${displayName})`

  return ComponentWithPreventFromUser
}
